import React from 'react'
import ReactSelect, { GroupBase, Props } from 'react-select'

export function Select<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
  return (
    <ReactSelect
      {...props}
      styles={{
        container: base => ({
          ...base,
          width: '100%',
          minWidth: '150px',
        }),
        control: base => ({
          ...base,
          borderColor: 'black',
          borderRadius: 9999,
          height: '42px',
          paddingLeft: '10px',
          boxShadow: 'none',
        }),
        menu: base => ({
          ...base,
          width: `calc(${base.width} - 40px)`,
          top: `calc(${base.top} - 8px)`,
          left: 20,
          borderRadius: 0,
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor:
            state.isFocused || state.isSelected ? '#00E3FF' : 'white',
          color: 'black',
          fontSize: '0,85rem',
        }),
        dropdownIndicator: base => ({
          ...base,
          color: 'black',
        }),
        indicatorSeparator: base => ({
          ...base,
          visibility: 'hidden',
        }),
      }}
    />
  )
}
